import { connect } from 'react-redux';
import Viewer from '../../components/Viewer/Viewer';
import { announce } from '../../actions/announcements';
import {
  boolFormatter,
  maxFormatter,
  valFormatter,
} from '../../utils/formatter';

const mapStateToProps = (state) => {
  const page = state.research.exercises.find((ex) => ex.category === 'spec');
  const spec = state.app.specification.settings;

  return {
    baseUrl: '/c/application/' + state.app.code,
    page: page.code,
    pageName: 'Design Challenge',
    templateParams: {
      spec,
      val: valFormatter(spec),
      bool: boolFormatter(spec),
      max: maxFormatter(spec),
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: (pageName) => {
    dispatch(announce(`${pageName} page loaded`));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Viewer);
